module.exports = __webpack_public_path__ + "static/media/2020Resume3.3.f0f48003.pdf";